import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { NutritionSodiumPotassiumDiagramContent } from "./NutritionSodiumPotassiumDiagram";
import { NutritionSodiumPotassiumKeyContent } from "./NutritionSodiumPotassiumKey";

const SvgNutritionSodiumPotassiumDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1284, 1534)}
      viewBox={diagramOnly ? "0 176 1024 1284" : "0 0 1024 1534"}
    >
      <g id="nutrition-sodium-potassium-diagram+key" clipPath="url(#clip0_18284_196604)">
        <rect width={1024} height={diagramOnly ? 1284 : 1534} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <NutritionSodiumPotassiumKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <NutritionSodiumPotassiumDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18284_196604">
          <rect width={1024} height={1534} fill="white" />
        </clipPath>
        <clipPath id="clip1_18284_196604">
          <rect width={1024} height={1284} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgNutritionSodiumPotassiumDiagramKey;
